// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';


export default function fatigueDefaultReducer(state = [], action) {
    switch (action.type) {
      
        case types.LOGOUT:
            return []
        case types.CREATE_FATIGUE_DEFAULT_SUCCESS: 
        
            var result = [...state, Object.assign({}, action.fatigueDefault)];
            return Sorter.sort(result,'fatigueDefaultId');
       
        case types.GET_FATIGUE_DEFAULT_SUCCESS:

            var result = [...state.filter(fatigueDefault => fatigueDefault.fatigueDefaultId !== action.fatigueDefault.fatigueDefaultId), Object.assign({}, action.fatigueDefault)];
            return Sorter.sort(result,'fatigueDefaultId');
            
        case types.UPDATE_FATIGUE_DEFAULT_SUCCESS:

            var result = [...state.filter(fatigueDefault => fatigueDefault.fatigueDefaultId !== action.fatigueDefault.fatigueDefaultId), Object.assign({}, action.fatigueDefault)];
            return Sorter.sort(result,'fatigueDefaultId');
        
        case types.LOAD_FATIGUE_DEFAULT_SUCCESS:

            return Sorter.sort(action.items,'fatigueDefaultId');

        case types.REMOVE_FATIGUE_DEFAULT_SUCCESS:

            var result = state.filter(fatigueDefault => fatigueDefault.fatigueDefaultId !== action.item);
            return Sorter.sort(result,'fatigueDefaultId');


        default:
            return state;
    };
};
